/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachines/Actions/VirtualMachineResourceActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { PackageMetadata } from "DistributedTask/Client/Contracts/TaskAgent";

export class VirtualMachineResourceActions extends ActionsHubBase {
    public static getKey(): string {
        return "virtualmachines-add-actions";
    }

    public initialize(instanceId?: string) {
        this._setTargetPackages = new Action<PackageMetadata[]>();
    }

    public get setTargetPackages() {
        return this._setTargetPackages;
    }
    
    private _setTargetPackages: Action<PackageMetadata[]>;
}